if (document.getElementsByClassName('accordion-list').length > 0) {

// Accordeon Function
let groups = gsap.utils.toArray(".accordion-group");
let menus = gsap.utils.toArray(".accordion-menu");
let menuToggles = groups.map(createAnimation);

menus.forEach((menu) => {
 menu.addEventListener("click", () => toggleMenu(menu));
});

function toggleMenu(clickedMenu) {
 menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}

function createAnimation(element) {
 let menu = element.querySelector(".accordion-menu");
 let box = element.querySelector(".accordion-content .accordion-item__contenttext__inner");
 let plusElement = element.querySelector(".button-circle");
 let buttonCirclePath = element.querySelector(".button-circle .button-circle-path");

 gsap.set(box, { height: "auto" });

 let animation = gsap
  .timeline({
    onComplete: () => plusElement.classList.add("is-active"),
    onReverseComplete: () => plusElement.classList.remove("is-active")
  })
  .from(box, {
    height: 0,
    duration: 0.5,
    ease: "power1.inOut"
  })
  .from(buttonCirclePath, { duration: 0.3, attr: { stroke:"#fafafa" }, ease:"none" }, 0)
  .to(buttonCirclePath, { duration: 0.3, attr: { stroke:"#232323" }, ease:"none" }, 0)
  .from(plusElement, { duration: 0.3, backgroundColor: '#232323', rotation: 0, ease:"none" }, 0)
  .to(plusElement, { duration: 0.3, backgroundColor: '#fafafa', rotation: 180, ease:"none" }, 0)
  .reverse();

 return function (clickedMenu) {
   if (clickedMenu === menu) {
     animation.reversed(!animation.reversed());
   } else {
     animation.reverse();
   }
 };
}



// Select the target node
const targetNode = document.querySelector('.accordion-list');

// Create a new MutationObserver instance
const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {

              // Accordeon Function
        let groups = gsap.utils.toArray(".accordion-group");
        let menus = gsap.utils.toArray(".accordion-menu");
        let menuToggles = groups.map(createAnimation);

        menus.forEach((menu) => {
        menu.addEventListener("click", () => toggleMenu(menu));
        });

        function toggleMenu(clickedMenu) {
        menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
        }

        function createAnimation(element) {
        let menu = element.querySelector(".accordion-menu");
        let box = element.querySelector(".accordion-content .accordion-item__contenttext__inner");
        let plusElement = element.querySelector(".button-circle");
        let buttonCirclePath = element.querySelector(".button-circle .button-circle-path");

        gsap.set(box, { height: "auto" });

        let animation = gsap
        .timeline({
          onComplete: () => plusElement.classList.add("is-active"),
          onReverseComplete: () => plusElement.classList.remove("is-active")
        })
        .from(box, {
          height: 0,
          duration: 0.5,
          ease: "power1.inOut"
        })
        .from(buttonCirclePath, { duration: 0.3, attr: { stroke:"#fafafa" }, ease:"none" }, 0)
        .to(buttonCirclePath, { duration: 0.3, attr: { stroke:"#232323" }, ease:"none" }, 0)
        .from(plusElement, { duration: 0.3, backgroundColor: '#232323', rotation: 0, ease:"none" }, 0)
        .to(plusElement, { duration: 0.3, backgroundColor: '#fafafa', rotation: 180, ease:"none" }, 0)
        .reverse();

        return function (clickedMenu) {
          if (clickedMenu === menu) {
            animation.reversed(!animation.reversed());
          } else {
            animation.reverse();
          }
        };
        }


    } else if (mutation.type === 'attributes') {

    }
  }
});

// Set observer configuration
const config = {
  childList: true, // Listen for child node additions/removals
  attributes: true, // Listen for attribute changes
  subtree: true, // Observe the entire subtree
};

// Start observing the target node
observer.observe(targetNode, config);

}
